import useAxiosRepository from '@/js/repositories/BaseRepository';
import { currencyConverterApiEndpoints } from '@/js/store/currency-converter/constants/currencyConverterApiEndpoints';
import { ApiCryptoCurrenciesResponse } from '@/js/cryptocurrencies/types/cryptocurrencyType';

const axiosRepo = useAxiosRepository();

export const fetchCryptoCurrencies = async ({
    search,
    page,
    perPage,
}: {
    search?: string;
    page?: number;
    perPage?: number;
}): Promise<ApiCryptoCurrenciesResponse> => {
    const queryParams = new URLSearchParams(
        Object.entries({
            'filter[combined]': search,
            page,
            perPage,
        })
            .filter(([, value]) => value !== undefined && value !== null)
            .map(([key, value]) => [key, String(value)]),
    );

    return axiosRepo.get(`${currencyConverterApiEndpoints.CRYPTO_CURRENCIES}?${queryParams}`);
};
